(function(){
  var KEY='__timeHero';
  function toBool(v){ if(v==null) return false; var s=String(v).toLowerCase().trim(); return (s==='true'||s==='on'||s==='1'||s==='yes'); }
  function ensureBtnType(el){ if(el && el.tagName==='BUTTON' && !el.hasAttribute('type')) el.setAttribute('type','button'); }

  function initOne(sectionEl){
    if(!sectionEl) return;
    var slider = sectionEl.querySelector('.time-slider');
    if(!slider) return;

    // Evita doble init
    if(slider[KEY] && slider[KEY].destroy){ slider[KEY].destroy(); }

    var effectAttr = String(slider.dataset.effect||'').toLowerCase().trim();
    var effect = (effectAttr==='slide') ? 'slide' : 'fade';
    slider.setAttribute('data-effect', effect);

    var autoplay    = toBool(slider.dataset.autoplay);
    var intervalSec = parseInt(slider.dataset.interval,10); if(isNaN(intervalSec)||intervalSec<=0) intervalSec=7;

    var track = slider.querySelector('.time-track');
    var slides = Array.prototype.slice.call(slider.querySelectorAll('.time-slide'));
    var dots   = Array.prototype.slice.call(slider.querySelectorAll('.time-dot-btn'));
    var prevBtn= slider.querySelector('.time-arrow.prev');
    var nextBtn= slider.querySelector('.time-arrow.next');
    if(!track || !slides.length) return;

    var index = Math.max(0, slides.findIndex(function(s){ return s.classList.contains('is-active'); }));
    if(index<0) index=0;

    if(effect==='slide'){
      track.style.display='flex';
      track.style.willChange='transform';
      track.style.width=(slides.length*100)+'%';
      track.style.transform='translate3d(' + (index*-100) + '%,0,0)';
    }

    var timer=null;
    function apply(){
      if(effect==='slide'){
        track.style.transform='translate3d(' + (index*-100) + '%,0,0)';
      }
      for(var i=0;i<slides.length;i++){
        var active=(i===index);
        slides[i].classList.toggle('is-active', active);
        slides[i].setAttribute('aria-hidden', active?'false':'true');
      }
      for(var j=0;j<dots.length;j++){
        var is=(j===index);
        dots[j].classList.toggle('is-active', is);
        dots[j].setAttribute('aria-current', is?'true':'false');
      }
    }
    function goTo(i){ index=(i+slides.length)%slides.length; apply(); restart(); }
    function next(){ goTo(index+1); }
    function prev(){ goTo(index-1); }
    function start(){ if(slides.length>1 && autoplay && !timer){ timer=setInterval(next, intervalSec*1000); } }
    function stop(){ if(timer){ clearInterval(timer); timer=null; } }
    function restart(){ stop(); start(); }

    ensureBtnType(prevBtn); ensureBtnType(nextBtn); dots.forEach(ensureBtnType);

    if(prevBtn) prevBtn.addEventListener('click', function(e){ e.preventDefault(); prev(); });
    if(nextBtn) nextBtn.addEventListener('click', function(e){ e.preventDefault(); next(); });

    sectionEl.addEventListener('click', function(e){
      var d = e.target && e.target.closest ? e.target.closest('.time-dot-btn') : null;
      if(d){ e.preventDefault(); var n=parseInt(d.getAttribute('data-go')||'0',10); goTo(isNaN(n)?0:n); }
    });

    // Swipe
    var sx=0, dx=0;
    slider.addEventListener('touchstart', function(e){ if(!e.touches||!e.touches.length) return; sx=e.touches[0].clientX; dx=0; stop(); }, {passive:true});
    slider.addEventListener('touchmove',  function(e){ if(!e.touches||!e.touches.length) return; dx=e.touches[0].clientX - sx; }, {passive:true});
    slider.addEventListener('touchend',   function(){ if(Math.abs(dx)>40){ dx<0?next():prev(); } start(); }, {passive:true});

    // Hover pause solo si hay ratón
    if(window.matchMedia && window.matchMedia('(hover:hover)').matches){
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
    }

    // Parallax botella
    var tiltEls = slider.querySelectorAll('.time-bottle-tilt');
    if(tiltEls.length){
      var maxRot=8, maxMove=10;
      slider.addEventListener('mousemove', function(e){
        var rect=slider.getBoundingClientRect();
        var rx=(e.clientX-rect.left)/rect.width - .5;
        var ry=(e.clientY-rect.top)/rect.height - .5;
        var rxDeg=(-ry*maxRot), ryDeg=(rx*maxRot);
        var tx=rx*maxMove, ty=ry*maxMove;
        for(var i=0;i<tiltEls.length;i++){
          tiltEls[i].style.setProperty('--rx', rxDeg+'deg');
          tiltEls[i].style.setProperty('--ry', ryDeg+'deg');
          tiltEls[i].style.setProperty('--tx', tx+'px');
          tiltEls[i].style.setProperty('--ty', ty+'px');
        }
      });
      slider.addEventListener('mouseleave', function(){
        for(var i=0;i<tiltEls.length;i++){
          tiltEls[i].style.setProperty('--rx','0deg');
          tiltEls[i].style.setProperty('--ry','0deg');
          tiltEls[i].style.setProperty('--tx','0px');
          tiltEls[i].style.setProperty('--ty','0px');
        }
      });
    }

    // Pausa al cambiar de pestaña
    document.addEventListener('visibilitychange', function(){
      if(document.hidden) stop(); else start();
    });

    apply(); setTimeout(start,80);

    slider[KEY]={ destroy: function(){ stop(); slider[KEY]=null; } };
  }

  function initAll(){
    document.querySelectorAll('.time-hero-slider').forEach(initOne);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Editor de Shopify / Savor section events
  document.addEventListener('shopify:section:load', function(e){
    var el = e.target && e.target.querySelector ? e.target.querySelector('.time-hero-slider') : null;
    if(el) initOne(el);
  });
  document.addEventListener('shopify:section:unload', function(e){
    var slider = e.target && e.target.querySelector ? e.target.querySelector('.time-hero-slider .time-slider') : null;
    if(slider && slider[KEY] && slider[KEY].destroy){ slider[KEY].destroy(); }
  });
})();
